<template>
    <div>
        <div id="mona" class="row py-2">
            <!-- <div class="col-sm bg-info" >1</div>
            <div class="col-sm bg-primary">2</div> -->

            <div class="col-sm d-flex align-items-end" id="idea">
                <div id="pub2" class="mb-4 text-center">
                    <h4>Atención al contribuyente</h4>
                    <a target="_blank" :href="'http://ayuda.ingresos.'+ urlSubdominio +'webim/client.php?locale=sp'"><h1>CHAT</h1></a>
                </div>
            </div>
            <div class="col-sm d-flex justify-content-center align-items-end">
                <div id="pub" class="pr-5 mb-4  text-center">
                    <hr id="pub3" class="d-none">
                    <h3>Asesoría fiscal</h3>
                    <h6>¡Lada gratuita!</h6>
                    <a href="tel:8008905920"><h1>800 890 5920</h1></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods:{
        resolucion(){
            if(screen.width > 1680){ //| monitores grandes |\\
                document.getElementById('mona').className = 'contenedor_mona_g row  py-2';
                document.getElementById('idea').className = 'col d-flex anuncioend align-items-end justify-content-end';
                document.getElementById('pub2').className = 'ml-5 marginB text-center';
                document.getElementById('pub').className = 'mt-2 marginB text-center';

            }else if(screen.width > 1023){ //| compu |\\
                console.log(screen.width);
                document.getElementById('mona').className = 'contenedor_mona_g row  py-2';
                document.getElementById('idea').className = 'col d-flex anuncioend align-items-end justify-content-end';
            }
            else if(screen.width >= 640){  //| tabletas |\\
                document.getElementById('pub2').className = 'ml-5 mb-4 text-center';
                document.getElementById('mona').className = 'contenedor_mona_p row  py-2';
            }else{
               //console.log('else'); //| celulares |\\
               document.getElementById('mona').className = 'contenedor_mona_p row py-2';
               document.getElementById('idea').className = 'col d-flex anunciocenter align-items-end';
               document.getElementById('pub').className = 'mt-2 mb-0 text-center';
               document.getElementById('pub2').className = 'mt-5 text-center';
               document.getElementById('pub3').className = 'd-block';
            }

        }
    },
    mounted(){
        this.resolucion();
    }
}
</script>
<style scoped>
.row {
    margin-right: 0;
    margin-left: 0;
}
h1, h3, h4, h6 { color:#c8c5b5; }
a{text-decoration: none;}
a:hover{ text-decoration: none; }

.marginB{margin-bottom: 3.5rem;}

/* cambia tamaño de fuente en pantallas enormes */
@media only screen and (min-device-width : 1900px){
    h4{ font-size: 2rem;}
    h3{ font-size: 2.2rem; }
}

</style>
